import { PropsWithChildren, useMemo } from 'react';
import styles from './InformationSection.module.scss';
import { VdsIcon } from '@volt/volt-extended-components-react';
import { AccordionStatus } from '@customer/components/accordions/types';
import type { IconColors, Colors } from '@volt/volt-basic-components/dist/types/definitions/colors';

export interface InformationSectionProps {
  status: AccordionStatus;
  title: string;
  icon: string;
  isPadded?: boolean;
}

export function InformationSection({
  status,
  title,
  icon,
  children,
  isPadded = true,
}: PropsWithChildren<InformationSectionProps>) {
  const iconColor = useMemo<IconColors | Colors>(() => {
    switch (status) {
      case AccordionStatus.Healthy:
        return 'green-500';

      case AccordionStatus.Caution:
        return 'yellow-500';

      case AccordionStatus.Warning:
        return 'orange-500';

      case AccordionStatus.Danger:
        return 'red-500';

      case AccordionStatus.Informative:
        return 'color-icon-brand-default';

      case AccordionStatus.Neutral:
      default:
        return 'color-icon-medium';
    }
  }, [status]);

  return (
    <section>
      <header className={styles.header}>
        <VdsIcon svgIcon={icon} size="32px" color={iconColor} />
        <div className={styles.title}>{title}</div>
      </header>
      <div className={`${styles.content} ${isPadded && styles['content--padded']}`}>{children}</div>
    </section>
  );
}

export default InformationSection;
